import { Check, ArrowRight } from "lucide-react";
import { ABOUT_IMG, scrollToId } from "@/data/site";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const POINTS = [
  "Quality ingredients, sourced with care",
  "Authentic taste, prepared fresh on site",
  "Beautiful presentation, plate to buffet",
  "Professional staff, smooth execution",
  "Attention to every detail of your event",
];

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-cream py-24 md:py-36">
    <div className="max-w-7xl mx-auto px-5 md:px-10 grid md:grid-cols-2 gap-12 md:gap-20 items-center">
      <Reveal className="relative">
        <div className="relative">
          <div className="absolute -top-4 -left-4 w-full h-full border border-gold/40 pointer-events-none" />
          <div className="overflow-hidden">
            <img
              src={ABOUT_IMG}
              alt="Momay Caterers chef in uniform plating food at an Indian wedding celebration"
              className="w-full aspect-[4/5] object-cover hover:scale-105 transition-transform duration-[1.2s]"
            />
          </div>
          <div className="absolute -bottom-8 -right-4 md:-right-8 bg-espresso text-cream px-8 py-6 shadow-2xl" data-testid="about-experience-badge">
            <span className="font-serif text-4xl md:text-5xl text-gold">25+</span>
            <span className="block text-[10px] tracking-[0.3em] uppercase mt-1 text-cream/70">Years of Craft</span>
          </div>
        </div>
      </Reveal>

      <div className="mt-10 md:mt-0">
        <SectionHeading chapter="01" eyebrow="About Momay" title="More Than Food." script="We create celebrations." />
        <Reveal delay={0.1}>
          <p className="mt-8 text-espresso/70 font-light leading-relaxed text-base md:text-lg">
            For over 25 years, Momay Caterers has believed that great celebrations are remembered through great food.
            We are not simply about serving dishes — we bring authentic taste, fresh preparation and thoughtful
            presentation together so that every plate feels like part of the occasion.
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <ul className="mt-8 space-y-3">
            {POINTS.map((p) => (
              <li key={p} className="flex items-center gap-3 text-espresso/80 text-sm md:text-base">
                <Check size={16} className="text-gold-dark shrink-0" />
                {p}
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.26}>
          <button
            data-testid="about-discover-btn"
            onClick={() => scrollToId("why")}
            className="mt-10 group inline-flex items-center gap-3 bg-espresso text-cream px-8 py-4 text-xs tracking-[0.25em] uppercase hover:bg-espresso-light transition-colors duration-300"
          >
            Discover Momay
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </Reveal>
      </div>
    </div>
  </section>
);
